import styled from '@emotion/styled';
import { Model } from '@gameonly/core';
import { useTranslation } from 'react-i18next';
import keyify from '../../../project/parameters/keyify';
import { blocks } from '../../../project/ProjectsUtils';
import NewButton from '../../../ui/NewButton';

type EmptyBlockContentProps = {
  color: string;
};

const EmptyBlockContent = styled.div`
  flex-grow: 1;
  background-color: ${(props: EmptyBlockContentProps) => props.color};
  height: 100%;
  width: 100%;
  display: flex;
  gap: 16px;
  flex: 1;
  p {
    max-width: 80%;
    text-align: center;
  }
`;

const Empty = ({
  model,
  onNewProject,
}: {
  model: Model;
  onNewProject?: (model: Model) => void;
}) => {
  const { t } = useTranslation(['model']);
  const translationPrefix = `model:${keyify(model.name)}`;
  return (
    <NewButton
      bgColor={blocks[model.type as keyof typeof blocks].barColor}
      createdObjectLabel={t(`${translationPrefix}.singularName`)}
      onClick={() => onNewProject && onNewProject(model)}
    />
  );
};

export default Empty;
